module.exports = __webpack_public_path__ + "fontawesome-webfont.svg?912ec66d7572ff821749319396470bde";